module.exports = __webpack_public_path__ + "img/Humanisme_Litteraturen.bd5bf237.jpg";